<template>
    <div :class="`partner-card d-flex ${isSidebarCollapsed} align-items-center`">
        <div class="w-100">
            <div class="d-flex align-items-center justify-content-between pl-5 pr-5">
                <div class="d-flex flex-column justify-content-center">
                    <h4 :class="`bold c-${getPrimaryColor}four mb-0`">
                        {{ cardTitle }}
                    </h4>
                    <p class="c-ndarkfour">Novo parceiro</p>
                </div>
                <div class="d-flex align-items-center justify-content-center">
                    <Button @click="toGoBack" class="ml-3" type="outline" :color="getPrimaryColor">
                        Voltar
                    </Button>
                    <Button @click="nextStep" class="ml-3"  :color="getPrimaryColor">
                        {{ buttonText }}
                    </Button>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
export default {
    props: {},
    data() {
        return {
            partnerId: '',
            cnpjId: '',
        }
    },
    methods: {
        nextStep() {
            if (this.partnerId && this.cnpjId) {
                return this.$emit('saveAllRules')
            } else if (this.partnerId) {
                return this.$emit('newMainRules')
            } else {
                return this.$emit('createNewPartner')
            }
        },
        toGoBack() {
            return this.$emit('toGoBack')
        }
    },
    computed: {
        isSidebarCollapsed() {
            const isCollapse = this.$store.state.tabs.collapse
            const addClass = isCollapse ? "sidebar-collapsed" : ""
            return addClass
        },
        cardTitle() {
            if (this.partnerId && this.cnpjId) {
                return 'Regras de cobrança'
            } else if (this.partnerId) {
                return 'Cadastrar financiadores'
            }
            return 'Dados gerais'
        },
        buttonText() {
            if (this.partnerId && this.cnpjId) {
                return 'Finalizar'
            }
            return 'Continuar'
        }
    },
    created() {
        this.partnerId = this.$route.params.partnerId
        this.cnpjId = this.$route.params.cnpjId
    }
}
</script>
    
<style lang="scss">
    $default-width: 256px;
    $sidebar-collapse-width: 56px;
    
    .partner-card {
        position: fixed;
        bottom: 0;
        z-index: 10;
        width: calc(100% - #{$default-width})!important;
        height: 110px;
        background-color: #FFFFFF;
        border: 1px solid #DFE2EB;
        border-radius: 6px 6px 0px 0px;
        @media screen and (min-width: 0px){
            margin-left: -24px      
        }
        @media screen and (min-width: 1280px){
            margin-left: -32px
        }
        @media screen and (min-width: 1560px){
            margin-left: -48px
        }
    }

    .sidebar-collapsed {
        width: calc(100% - #{$sidebar-collapse-width})!important;   
    }
</style>